import React, { useEffect, useRef } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import Container, { Input } from './styles';

const SearchBar = ({
  placeholder,
  handleChange,
  inputValue,
  testId,
  moveToSearch,
}) => {
  const inputEl = useRef(null);
  const history = useHistory();

  useEffect(() => {
    if (inputEl.current && window.location.pathname !== '/') {
      inputEl.current.focus();
    }
  }, []);

  const handleRoute = () => {
    history.push('/search');
  };

  const checkRoute = () => {
    if (moveToSearch && window.location.pathname !== '/search') {
      handleRoute();
    }
  };

  return (
    <Container>
      <Input
        ref={inputEl}
        placeholder={placeholder}
        type="text"
        data-testid={testId}
        onClick={() => checkRoute()}
        onChange={(e) => {
          handleChange(e);
          checkRoute();
        }}
        value={inputValue}
      />
      <SearchIcon
        style={{ color: 'gray', transform: 'rotate(90deg)', opacity: '0.6' }}
      />
    </Container>
  );
};

SearchBar.propTypes = {
  placeholder: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  inputValue: PropTypes.string.isRequired,
  testId: PropTypes.string,
  moveToSearch: PropTypes.bool,
};

SearchBar.defaultProps = {
  testId: '',
  moveToSearch: false,
};

export default SearchBar;
